import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import APP_CONFIG from "../app/configuration/AppConfig";
import { SubscriptionsBySite } from "./Models";

export const fetchSubscriptions = createAsyncThunk<SubscriptionsBySite, void>(
  "subscriptions/fetch",
  async (_, { signal }) => {
    const response = await axios.post<SubscriptionsBySite>(
      `${APP_CONFIG.serviceUrls.apiHostUrl}/subscriptions/getMultisite`,
      undefined,
      { signal, timeout: 30000 }
    );
    return response.data;
  }
);

interface SubscriptionsState {
  bySite: SubscriptionsBySite;
  activeRequestId?: string;
}

const initialState: SubscriptionsState = { bySite: {} };
const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    clearSubscriptions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptions.pending, (state, action) => {
        state.activeRequestId = action.meta.requestId;
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) {
          return;
        }
        state.bySite = action.payload;
        delete state.activeRequestId;
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) {
          return;
        }
        if (!action.meta.aborted) {
          state.bySite = Object.fromEntries(
            Object.keys(state.bySite).map((siteId) => [
              siteId,
              { status: "unavailable", productExpirationDate: null },
            ])
          );
        }
        delete state.activeRequestId;
      });
  },
});

export const { clearSubscriptions } = subscriptionsSlice.actions;
export const subscriptionsReducer = subscriptionsSlice.reducer;
